export default function saveFile(
    source: string,
    filename = 'export.txt',
    type = 'text/plain'
) {
    const data = new Blob([source], { type });
    const toggle = document.createElement('a');
    toggle.download = filename;
    toggle.href = URL.createObjectURL(data);
    toggle.click();
}
